import {Component} from '@angular/core';
import {CONCESSIONARIAS_EMAIL_KEY, CONCESSIONARIAS_EMAIL_SENT_KEY} from '@shared/constants/storage-keys';
import {ToastModule} from "primeng/toast";
import {MessageService} from "primeng/api";
import {CardModule} from 'primeng/card';
import {Router} from '@angular/router';
import {AuthService} from '../../core/services/auth.service';
import {IconUserGovbrComponent} from "../../components/icons/icon-user-govbr/icon-user-govbr.component";
import {NgOptimizedImage} from "@angular/common";
import {IconKeyComponent} from "../../components/icons/icon-key/icon-key.component";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ToastModule,
    CardModule,
    IconUserGovbrComponent,
    NgOptimizedImage,
    IconKeyComponent,
  ],
  providers: [MessageService],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {
  }

  onLoginGov() {
    this.authService.loginWithGovbr();
  }

  onLoginConcessionarias() {
    sessionStorage.removeItem(CONCESSIONARIAS_EMAIL_KEY);
    sessionStorage.removeItem(CONCESSIONARIAS_EMAIL_SENT_KEY);
    this.router.navigate(['/auth/login-concessionarias']).then(r => r);
  }
}
